module.exports = __webpack_public_path__ + "img/atl1.89413332.jpg";